import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, NavLink, useHistory } from "react-router-dom";
import Storage from "../../utils/storage";
import HomeIcon from "../../assets/assets/dashboard.svg";
import Logo from "../../assets/assets/Nibss-Logo.png";
import Staff from "../../assets/assets/add-user.svg";
import LogOutIcon from "../../assets/assets/shutdown.svg";
import Settings from "../../assets/assets/profile.svg";
import Contact from "../../assets/assets/contacts.svg";
import Person from "../../assets/assets/person-icon.svg";
import Email from "../../assets/assets/email-icon.svg";
import Call from "../../assets/assets/phone.svg";
import UserModal from "../EmailModal/UserModal";
import { PropTypes } from "prop-types";
import { sidebarActions } from "./sidebarActions";
import { mapDispatchToProps } from "../Nip/mapDispatchToProps";

export const Sidebar2 = ({
  getStatus,
  isGetting,
  dashboardData,
  isLoggingOut,
  logOut,
}) => {
  let userToken = Storage.get("user-access-token");
  const history = useHistory()

  const logout = () => {
    const payload = {
      access_token: userToken
    }
    logOut(payload, history)
  }

  useEffect(
    () => {
      getStatus();
    },
    // eslint-disable-next-liner4
    [getStatus]
  );

  const [state, setState] = useState({
    showModal: false,
    hideModal: true,
  });

  const showModal = () => {
    setState({
      ...state,
      showModal: true,
    });
  };

  const hideModal = () => {
    setState({
      ...state,
      hideModal: true,
      showModal: false,
    });
  };

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let userType = user && user.type;
  const status =
    dashboardData && dashboardData[0] && dashboardData[0].default_application;
  const accountOfficer =
    status && status[0] && status[0] && status[0].account_officer_info;
  const accountOfficerEmail = accountOfficer && accountOfficer.email;
  const accountOfficerNumber = accountOfficer && accountOfficer.contact_no;
  const accountOfficerFirstName = accountOfficer && accountOfficer.first_name;
  const accountOfficerLastName = accountOfficer && accountOfficer.last_name;

  return (
    <div className="sidebar2">
      <div className="sidebar2-logo">
        <input type="checkbox" id="nav-check" />
        <div className="sidebar2-left">
          <label htmlFor="nav-check">
            <div className="close"></div>
          </label>
        </div>
        <Link to="/">
          <div className="sidebar2-logo-section">
            <img src={Logo} alt="logo" />
          </div>
        </Link>
      </div>
      <div className="side-links">
        <NavLink to="/dashboard" activeClassName="green">
          <div className="sidebar2-item">
            <div className="sidebar2-item-icon">
              <img src={HomeIcon} alt="home-icon" />
            </div>
            <span>Dashboard</span>
          </div>
        </NavLink>
        {userType === "company" && (
          <NavLink to="/staff" activeClassName="green">
            <div className="sidebar2-item">
              <div className="sidebar2-item-icon">
                <img src={Staff} alt="add-icon" />
              </div>
              <span>Staff Management</span>
            </div>
          </NavLink>
        )}
        <NavLink to="/settings" activeClassName="green">
          <div className="sidebar2-item">
            <div className="sidebar2-item-icon">
              <img src={Settings} alt="settings-icon" />
            </div>
            <span>Profile</span>
          </div>
        </NavLink>
      </div>
      <br />
      <br />
      <br />
      <div className="sideline-break"></div>
      <br />
      <div className="sidebar2-item" onClick={logout} data-testid="logout">
        <div className="sidebar2-item-icon">
          <img src={LogOutIcon} alt="logout-icon" />
        </div>
        <span>{isLoggingOut ? "Logging Out..." : "Log Out"}</span>
      </div>
      <br />
      <br />
      <br />
      <br />
      {userType === "company" && (
        <div>
          <button
            className="sidebar2-item2"
            onClick={showModal}
            disabled={
              (accountOfficer && Object.entries(accountOfficer).length === 0) ||
              isGetting ||
              (dashboardData && dashboardData.length === 0) ||
              (status && status.length === 0)
            }
          >
            <div className="sidebar2-item2-icon">
              <img src={Contact} alt="logout-icon" />
            </div>
            <span>Account Officer</span>
          </button>
        </div>
      )}

      <UserModal
        open={state.showModal}
        close={hideModal}
        height={"550"}
        width={"500"}
      >
        <div className="modal-header2">
          <img src={Contact} alt="person" style={{ float: "left" }} />
          <h1>ACCOUNT OFFICER</h1>
        </div>

        {accountOfficer && Object.entries(accountOfficer).length === 0 ? (
          <div className="side-acct">
            <div className="side-acct-info">
              You have not be assigned to an account officer. Please check back
              after your application has been accepted.
            </div>
          </div>
        ) : (
          <div className="side-acct">
            <div className="side-acct-info">
              Please contact your account officer for any issues related with
              your account or for general assistance
            </div>

            <div className="side-acct-info-details">
              <p>
                <img src={Person} alt="icon" />
                <span>
                  {accountOfficerFirstName} {accountOfficerLastName}
                </span>
              </p>
              <p>
                <img src={Email} alt="icon" />
                <a href={`mailto:${accountOfficerEmail}`}>
                  {accountOfficerEmail}
                </a>
              </p>
              <p>
                <img src={Call} alt="icon" />
                <a href={`tel:${accountOfficerNumber}`}>
                  {accountOfficerNumber}
                </a>
              </p>
            </div>
          </div>
        )}
        <div className="modal-form">
          <div className="modal-input-button">
            <button
              className="modal-close-button"
              type="button"
              onClick={hideModal}
            >
              CLOSE
            </button>
          </div>
        </div>
      </UserModal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return sidebarActions(state)
};

Sidebar2.propTypes = {
  dashboardData: PropTypes.array,
  getStatus: PropTypes.func,
  isGetting: PropTypes.bool,
  isLoggingOut: PropTypes.bool,
  logOut: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar2);
